import React from 'react';
import { Link } from 'react-router-dom';
interface ButtonProps {
  children: React.ReactNode;
  variant?: 'primary' | 'secondary' | 'outline';
  size?: 'sm' | 'md' | 'lg';
  href?: string;
  onClick?: () => void;
  className?: string;
  type?: 'button' | 'submit' | 'reset';
  external?: boolean;
}
export function Button({
  children,
  variant = 'primary',
  size = 'md',
  href,
  onClick,
  className = '',
  type = 'button',
  external = false
}: ButtonProps) {
  const baseStyles = 'inline-flex items-center justify-center font-medium transition-colors rounded-md focus:outline-none focus:ring-2 focus:ring-offset-2 focus:ring-coral-dark';
  const variantStyles = {
    primary: 'bg-coral-dark text-white hover:bg-coral shadow-sm',
    secondary: 'bg-sage text-navy-dark hover:bg-sage-dark hover:text-white shadow-sm',
    outline: 'border border-navy bg-transparent text-navy-dark hover:bg-navy-light hover:text-white'
  };
  const sizeStyles = {
    sm: 'px-3 py-1.5 text-sm',
    md: 'px-4 py-2 text-base',
    lg: 'px-6 py-3 text-lg'
  };
  const styles = `${baseStyles} ${variantStyles[variant]} ${sizeStyles[size]} ${className}`;
  if (href) {
    if (external) {
      return <a href={href} className={styles} target="_blank" rel="noopener noreferrer" data-id="element-22">
          {children}
        </a>;
    }
    return <Link to={href} className={styles} data-id="element-23">
        {children}
      </Link>;
  }
  return <button type={type} className={styles} onClick={onClick} data-id="element-24">
      {children}
    </button>;
}